export function joinBaseURLWithPath(filePath: string): string {
  return `${process.env.REACT_APP_ARVAN_S3_BASE_URL}${filePath}`;
}
